import React from 'react';
// import { Routes, Route } from "react-router-dom";

import styles from './styles.module.scss';

const ErrorPage = ({ contact, status}) => {
  console.log(status);

  return (
    <div className={styles.errorPage}>
      <div className={styles.cendot}>
        <div className={styles.dialog}>
          <h1>Произошла ошибка на сервере.</h1>
          <p>Чтобы продолжить работу, вы можете вернуться на <a href="/" className={styles.errorLnk}>главную</a></p>
          <div className={styles.blod}>
            <span className={styles.ErrorBalloon} alt="ошибка" />
            <div className={styles.errorCode}>404</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ErrorPage;
